module.exports = __webpack_public_path__ + "static/img/81.c375378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/81.jpg
// module id = aSgl
// module chunks = 0